import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IBakiyeSiparisleri_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBakiyeSiparisleri_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  DeletBakiyeSiparisleri: number;
  DeletBakiyeSiparisleri_dummy: number;
  GetBakiyeSiparisleri: any[];
  GetBakiyeSiparisleri_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  isComp433962Visible: "visible" | "hidden";
}

export class BakiyeSiparisleri_ScreenBase extends React.PureComponent<
  IBakiyeSiparisleri_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  bakiyesiparisleri_991101_value_kuikaDateRef: React.RefObject<any>;
  bakiyesiparisleri_531018_value_kuikaDateRef: React.RefObject<any>;
  bakiyesiparisleri_501002_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 853770,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORD TO VIEW",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 895232,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 385412,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 573333,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "ORDER DATE",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "YPS ORDER NO",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "STOCK NO",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "STOCK NAME",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "ORDER AMOUNT",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "SHIPPED AMOUNT",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "REMAIN AMOUNT",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 181005,
          PropertyName: "title",
          Value: "UNIT CURRENCY PRICE",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 987438,
          PropertyName: "title",
          Value: "CURRENCY",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 257016,
          PropertyName: "title",
          Value: "DISCOUNT",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 701929,
          PropertyName: "title",
          Value: "NET CURRENCY UNIT PRICE",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 15050,
          PropertyName: "title",
          Value: "SHIPPED NET CURRENCY AMOUNT",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 80789,
          PropertyName: "title",
          Value: "REMAIN NET CURRENCY AMOUNT",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 690685,
          PropertyName: "title",
          Value: "CUSTOMER ORDER NO",
          TagName: "TableTemplateColumn14_title",
        },
        {
          Id: 510596,
          PropertyName: "title",
          Value: "CUSTOMER CROSS ID",
          TagName: "TableTemplateColumn15_title",
        },
        {
          Id: 652334,
          PropertyName: "value",
          Value: "REMAIN ORDERS",
          TagName: "Label20_value",
        },
        {
          Id: 419276,
          PropertyName: "value",
          Value: "LISTED ORDERS DOESNOT SHIPPED",
          TagName: "Label21_value",
        },
        {
          Id: 991101,
          PropertyName: "placeholder",
          Value: "START DATE",
          TagName: "Date3_placeholder",
        },
        {
          Id: 531018,
          PropertyName: "placeholder",
          Value: "END DATE",
          TagName: "Date2_placeholder",
        },
        {
          Id: 162944,
          PropertyName: "label",
          Value: "VIEW",
          TagName: "Button1_label",
        },
        {
          Id: 892895,
          PropertyName: "label",
          Value: "EXPORT EXCEL FORMAT",
          TagName: "Button2_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 853770,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontró registro para agregar",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 573333,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "Fecha del pedido",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "No. de pedido de Yps",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "Código de inventario",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Nombre del inventario",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Cantidad del pedido",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Cantidad de envío",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Cantidad restante",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 181005,
          PropertyName: "title",
          Value: "Precio unitario en divisas",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 987438,
          PropertyName: "title",
          Value: "Definición de moneda",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 257016,
          PropertyName: "title",
          Value: "Descuento",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 701929,
          PropertyName: "title",
          Value: "Precio unitario neto en divisas",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 15050,
          PropertyName: "title",
          Value: "Importe neto en divisas de envío",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 80789,
          PropertyName: "title",
          Value: "Importe restante en divisas",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 690685,
          PropertyName: "title",
          Value: "No. de pedido del cliente",
          TagName: "TableTemplateColumn14_title",
        },
        {
          Id: 510596,
          PropertyName: "title",
          Value: "Código cruzado del cliente",
          TagName: "TableTemplateColumn15_title",
        },
        {
          Id: 652334,
          PropertyName: "value",
          Value: "Saldo de pedidos",
          TagName: "Label20_value",
        },
        {
          Id: 419276,
          PropertyName: "value",
          Value: "Lista de pedidos no entregados",
          TagName: "Label21_value",
        },
        {
          Id: 991101,
          PropertyName: "placeholder",
          Value: "Fecha de inicio",
          TagName: "Date3_placeholder",
        },
        {
          Id: 531018,
          PropertyName: "placeholder",
          Value: "Fecha de finalización",
          TagName: "Date2_placeholder",
        },
        {
          Id: 162944,
          PropertyName: "label",
          Value: "Lista",
          TagName: "Button1_label",
        },
        {
          Id: 892895,
          PropertyName: "label",
          Value: "Exportar a Excel",
          TagName: "Button2_label",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 853770,
          PropertyName: "placeholder",
          Value: "Vaden no, OEM no, Produit, Marque, Modèle, Véhicule ",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun résultat",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 573333,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "Date commande",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "N° commande YPS",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "Code produit",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Produit",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Quantité commandée",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Quantité livrée",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Quantité restante",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 181005,
          PropertyName: "title",
          Value: "Prix unitaire en devise",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 987438,
          PropertyName: "title",
          Value: "Devise",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 257016,
          PropertyName: "title",
          Value: "Remise",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 701929,
          PropertyName: "title",
          Value: "Prix net unitaire en devise",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 15050,
          PropertyName: "title",
          Value: "Montant net livré en devise",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 80789,
          PropertyName: "title",
          Value: "Montant net restant en devise",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 690685,
          PropertyName: "title",
          Value: "N° commande client",
          TagName: "TableTemplateColumn14_title",
        },
        {
          Id: 510596,
          PropertyName: "title",
          Value: "Réf. client ",
          TagName: "TableTemplateColumn15_title",
        },
        {
          Id: 652334,
          PropertyName: "value",
          Value: "Commandes en attente",
          TagName: "Label20_value",
        },
        {
          Id: 419276,
          PropertyName: "value",
          Value: "Commandes non livrées",
          TagName: "Label21_value",
        },
        {
          Id: 991101,
          PropertyName: "placeholder",
          Value: "Date de début",
          TagName: "Date3_placeholder",
        },
        {
          Id: 531018,
          PropertyName: "placeholder",
          Value: "Date de fin",
          TagName: "Date2_placeholder",
        },
        {
          Id: 162944,
          PropertyName: "label",
          Value: "Afficher",
          TagName: "Button1_label",
        },
        {
          Id: 892895,
          PropertyName: "label",
          Value: "Envoyer vers Excel",
          TagName: "Button2_label",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "5ce1f361-aa3d-420f-bf22-f18f0ef5e024",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 853770,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 895232, PropertyName: "label", Value: "Turkish" },
        { Id: 385412, PropertyName: "label", Value: "English" },
        { Id: 139513, PropertyName: "label", Value: "Spanish" },
        { Id: 752638, PropertyName: "label", Value: "French" },
        { Id: 573333, PropertyName: "label", Value: "Profil" },
        { Id: 652334, PropertyName: "value", Value: "Bakiye Siparişleri" },
        {
          Id: 419276,
          PropertyName: "value",
          Value: "Teslim Edilmemiş Siparişler Listelenir",
        },
        { Id: 991101, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 531018, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 162944, PropertyName: "label", Value: "Listele" },
        { Id: 892895, PropertyName: "label", Value: "Excele Aktar" },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 435981, PropertyName: "title", Value: "Sip.Tarih" },
        { Id: 653107, PropertyName: "value", Value: "[datafield:sip_tarih]" },
        { Id: 197987, PropertyName: "title", Value: "Yps SipNo" },
        { Id: 926385, PropertyName: "value", Value: "[datafield:siparis_no]" },
        { Id: 501159, PropertyName: "title", Value: "Stok Kod" },
        { Id: 455729, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 835743, PropertyName: "title", Value: "Stok Ad" },
        { Id: 941477, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 687263, PropertyName: "title", Value: "Sipariş Mik." },
        { Id: 342464, PropertyName: "value", Value: "[datafield:sipmik]" },
        { Id: 431288, PropertyName: "title", Value: "Sevk. Miktarı" },
        {
          Id: 477062,
          PropertyName: "value",
          Value: "[datafield:teslim_miktar]",
        },
        { Id: 280373, PropertyName: "title", Value: "Kalan Mik." },
        {
          Id: 718258,
          PropertyName: "value",
          Value: "[datafield:kalan_miktar]",
        },
        { Id: 181005, PropertyName: "title", Value: "Birim Dov. Fiyat" },
        {
          Id: 905574,
          PropertyName: "value",
          Value: "[datafield:brut_doviz_fiyati]",
        },
        { Id: 987438, PropertyName: "title", Value: "Doviz Tanım" },
        { Id: 130878, PropertyName: "value", Value: "[datafield:doviz_ismi]" },
        { Id: 257016, PropertyName: "title", Value: "Iskonto" },
        {
          Id: 871005,
          PropertyName: "value",
          Value: "[datafield:doviz_isk_orani1]",
        },
        { Id: 701929, PropertyName: "title", Value: "Net Dov. Bir. Fiyat" },
        {
          Id: 977797,
          PropertyName: "value",
          Value: "[datafield:net_doviz_fiyat]",
        },
        { Id: 15050, PropertyName: "title", Value: "Sevk Net Döv.Tutar" },
        {
          Id: 797612,
          PropertyName: "value",
          Value: "[datafield:teslim_edilen_net_dov_tutar]",
        },
        { Id: 80789, PropertyName: "title", Value: "Kalan Net Döv. Tutar" },
        {
          Id: 429390,
          PropertyName: "value",
          Value: "[datafield:net_kalan_dov_tutar]",
        },
        { Id: 690685, PropertyName: "title", Value: "Müşteri Sip No" },
        {
          Id: 168392,
          PropertyName: "value",
          Value: "[datafield:musteri_sip_no]",
        },
        { Id: 510596, PropertyName: "title", Value: "Müşteri Cross Kod" },
        { Id: 418213, PropertyName: "value", Value: "[datafield:oem_no]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.bakiyesiparisleri_853770_value_kuikaTextInputRef = React.createRef();
    this.bakiyesiparisleri_991101_value_kuikaDateRef = React.createRef();
    this.bakiyesiparisleri_531018_value_kuikaDateRef = React.createRef();
    this.bakiyesiparisleri_501002_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetParametreler: [],
      GetLanguage: "",
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetToplamTeklifSepeti: [],
      DeletBakiyeSiparisleri: 0,
      GetBakiyeSiparisleri: [],
      ExportExcel: "",
      dataSource_98882: [
        { key: "0", text: "Bekleyen" },
        { key: "1", text: "Teslim Edilmiş" },
        { text: "Tümü", key: "2" },
      ],
      isComp433962Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "bakiyesiparisleri",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.BakiyeSiparisleriPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.BakiyeSiparisleriPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "bakiyesiparisleri",
      "blank_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "bakiyesiparisleri",
      "blank_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BakiyeSiparisleriPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.BakiyeSiparisleriPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BakiyeSiparisleriPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakiyeSiparisleri/BakiyeSiparisleriPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp433962Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakiyeSiparisleriPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakiyeSiparisleriPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakiyeSiparisleriPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakiyeSiparisleriPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakiyeSiparisleri/BakiyeSiparisleriPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.bakiyesiparisleri_936723_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakiyeSiparisleriPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakiyeSiparisleriPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakiyeSiparisleriPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakiyeSiparisleriPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      CARI_KOD_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      KalanFiltre_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_98882_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      firmaKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      bastar_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_991101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      bitar_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_531018_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakiyeSiparisleri/BakiyeSiparisleriPageInit4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.bakiyesiparisleri_683777_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.bakiyesiparisleri_960073_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.DeletBakiyeSiparisleri = result?.data.deletBakiyeSiparisleri;
    stateVars.GetBakiyeSiparisleri = result?.data.getBakiyeSiparisleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakiyeSiparisleriPageInit5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakiyeSiparisleriPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bakiyesiparisleri_960073_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp433962Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.bakiyesiparisleri_683777_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.bakiyesiparisleri_936723_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.bakiyesiparisleri_483695_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    stateVars.dataSource_501002 =
      stateVars.GetBakiyeSiparisleri ?? this.state.GetBakiyeSiparisleri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_853770_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_853770_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakiyeSiparisleri",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_433962_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakiyeSiparisleri",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_997178_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakiyeSiparisleri",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "141547",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_895232_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_385412_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_139513_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_752638_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_573333_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakiyeSiparisleri",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_162944_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KalanFiltre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_98882_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      firmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      bastar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_991101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      bitar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_531018_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakiyeSiparisleri/BakiyeSiparisleriComponent_162944_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBakiyeSiparisleri = result?.data.getBakiyeSiparisleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BakiyeSiparisleriComponent_162944_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakiyeSiparisleriComponent_162944_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_501002 =
      stateVars.GetBakiyeSiparisleri ?? this.state.GetBakiyeSiparisleri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_892895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.GetBakiyeSiparisleri),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakiyeSiparisleri/BakiyeSiparisleriComponent_892895_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_98882_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KalanFiltre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_98882_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      firmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      bastar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_991101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      bitar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakiyesiparisleri_531018_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakiyeSiparisleri/BakiyeSiparisleriComponent_98882_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBakiyeSiparisleri = result?.data.getBakiyeSiparisleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BakiyeSiparisleriComponent_98882_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakiyeSiparisleriComponent_98882_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_501002 =
      stateVars.GetBakiyeSiparisleri ?? this.state.GetBakiyeSiparisleri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakiyeSiparisleriComponent_941477_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 141547] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BakiyeSiparisleriPageInit();
    }
  }
}
